import { css } from '@emotion/css';
import {
  ColorsWhite,
  ColorsNeutral400,
  ColorsNeutral300,
  ColorsNeutral200,
  ColorsPrimary900,
  ColorsPrimary500,
  Dimensions1,
  Dimensions2,
  Dimensions3,
  Dimensions5,
  Dimensions7,
  Dimensions8,
  Radius1,
  ShadowsBox,
  ColorsNeutral100,
  ColorsBlack,
} from '@efexteam/design-tokens';
import { NAVBAR_DIMENSIONS } from './constants/navbar.constants';

const navbarContainer = css({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  padding: Dimensions5,
  alignItems: 'center',
  borderBottom: `1px solid ${ColorsNeutral300}`,
  zIndex: 100,
  backgroundColor: ColorsPrimary900,
  '@media (min-width: 768px)': {
    height: '80px',
    paddingLeft: Dimensions7,
    paddingRight: Dimensions7,
  },
  '@media (min-width: 1024px)': {
    backgroundColor: ColorsWhite,
  },
});

const hamburgerButton = css({
  position: 'relative',
  display: 'block',
  cursor: 'pointer',
  zIndex: 101,
  padding: Dimensions2,
  touchAction: 'manipulation',
  '@media (min-width: 1024px)': {
    '&&': {
      display: 'none',
    },
  },
});

const hamburgerIconContainer = css({
  width: Dimensions8,
  height: Dimensions8,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  touchAction: 'manipulation',
});

const hamburgerLine = css({
  position: 'absolute',
  height: '3px',
  transition: 'all 0.5s ease',
  borderRadius: Radius1,
  width: Dimensions8,
  backgroundColor: ColorsWhite,
});

const hamburgerLineTop = css({
  transform: 'translateY(-10px)',
  '&.active': {
    transform: 'rotate(45deg)',
    transformOrigin: 'center',
  },
});

const hamburgerLineBottom = css({
  transform: 'translateY(10px)',
  '&.active': {
    transform: 'rotate(-45deg)',
    transformOrigin: 'center',
  },
});

const clockContainer = css({
  display: 'none',
  '@media (min-width: 768px)': {
    display: 'block',
  },
});

const navbarItemsContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: Dimensions2,
});

const avatarContainer = css({
  display: 'flex',
  alignItems: 'center',
});

const profileButton = css({
  padding: Dimensions1,
  borderRadius: Radius1,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  color: ColorsNeutral400,
  backgroundColor: ColorsNeutral100,
  backdropFilter: 'blur(4px)',
  border: `1px solid ${ColorsNeutral200}`,
  boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, 0.05)`,
  transition: 'box-shadow 0.2s ease-in-out',
  height: `${NAVBAR_DIMENSIONS.MOBILE_HEIGHT}px`,
  gap: Dimensions1,

  '&:hover': {
    boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, 0.1)`,
  },

  '& svg': {
    width: Dimensions5,
    height: Dimensions5,
  },

  '@media (min-width: 768px)': {
    padding: Dimensions2,
    paddingRight: Dimensions2,
    height: `${NAVBAR_DIMENSIONS.DESKTOP_HEIGHT}px`,
  },
});

const avatarWrapper = css({
  borderRadius: '50%',
  display: 'inline-block',
});

const avatarTextContainer = css({
  display: 'none',
  '@media (min-width: 768px)': {
    display: 'block',
  },
});

const avatarText = css({
  margin: 0,
  marginLeft: Dimensions1,
  fontSize: '14px',
});

const avatarPlaceholder = css({
  height: '35px',
  width: '35px',
  backgroundColor: ColorsNeutral200,
  '@media (min-width: 768px)': {
    height: '47px',
    width: '140px',
  },
});

const langSelectorContainer = css({
  marginLeft: Dimensions3,
});

const menuItemLink = css({
  textDecoration: 'none',
  color: ColorsBlack,

  '&:hover': {
    color: ColorsPrimary500,
  },
});

const menuItemContent = css({
  '&&&': {
    fontSize: '14px',
    paddingTop: Dimensions2,
    paddingBottom: Dimensions2,
    gap: Dimensions2,

    '&:hover': {
      color: ColorsPrimary500,
    },
  },
});

const navbarStyles = {
  navbarContainer,
  hamburgerButton,
  hamburgerIconContainer,
  hamburgerLine,
  hamburgerLineTop,
  hamburgerLineBottom,
  clockContainer,
  navbarItemsContainer,
  avatarContainer,
  profileButton,
  avatarWrapper,
  avatarTextContainer,
  avatarText,
  avatarPlaceholder,
  langSelectorContainer,
  menuItemLink,
  menuItemContent,
};

export default navbarStyles;
